module.exports = __webpack_public_path__ + "files/fcb1eb5af94ba5ddef1135ed3cd66652.svg";